var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "toggle-wrapper" }, [
    _c("div", { staticClass: "toggle" }, [
      _c("input", {
        attrs: {
          type: "checkbox",
          id: "is-live-" + _vm.id,
          disabled: _vm.disabled
        },
        domProps: { checked: _vm.checked },
        on: {
          change: function($event) {
            _vm.$emit("change", $event.target.checked)
          }
        }
      }),
      _vm._v(" "),
      _c("label", { attrs: { for: "is-live-" + _vm.id } }, [_vm._v("Toggle")])
    ]),
    _vm._v(" "),
    _c(
      "span",
      {
        staticClass: "text",
        class: { "online-text": _vm.checked, "opacity-06": _vm.disabled }
      },
      [_vm._v(_vm._s(_vm.text))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e0f45076", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0f45076","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/Toggle.vue
// module id = 1630
// module chunks = 1